import { lazy, Suspense } from 'react';
import Spin from 'components/Spin';
import type { IBrandConfig } from './types';

const MissGroupSafeTermsOfService = lazy(
  () => import('pages/terms-of-service/miss-group-safe'),
);

const MG_SAFE_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: { kind: 'cms', path: 'policy/mgsafe-policy.md' },
  termsOfService: {
    kind: 'component',
    render: () => (
      <Suspense fallback={<Spin />}>
        <MissGroupSafeTermsOfService />
      </Suspense>
    ),
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  vaultProject: 'eyeon',
  adaChat: false,
  accountDetails: true,
  secureUpload: true,
  plan: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  defaultBillingCategoryKey: 'privacy_breach',
  copyRightEntity: 'Miss Group Safe',
  hasCustomerServiceSupport: false,
  ssoRedirectURL: null,
  carouselBanners: false,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability: null,
  },
  supportPage: {
    pageTitle: {
      active: false,
    },
    customerSupportTitle: {
      active: false,
    },
    faq: {
      active: true,
    },
    pages: [
      {
        title: 'Miss Hosting SE/NO:',
        href: 'https://misshosting.help',
        icon: 'support-faq',
        customerSupport: true,
      },
      {
        title: 'Domene:',
        href: 'https://www.domene.no/kontakt',
        icon: 'support-faq',
        customerSupport: true,
      },
      {
        title: 'Hemsida24:',
        href: 'https://hemsida24.help/sv',
        icon: 'support-faq',
        customerSupport: true,
      },
    ],
    call: {},
    mail: {
      active: false,
    },
    email: {
      active: false,
    },
  },
};

export default MG_SAFE_BRAND_CONFIG;
